import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './modules/auth/auth.module';
import { MaterialModule } from './modules/material/material.module';
import { ServicesModule } from './services/services.module';
import { ProductsModule } from './modules/products/products.module';
import { OffersModule } from './modules/offers/offers.module';
import { CookieService } from 'ng2-cookies';
import { AuthGuard } from './services/auth.guard';
import { OfferLifecycleModule } from './modules/lifecycle/lifecycle.module';
import { ToastModule } from 'ng2-toastr';
import { RegulationsModule } from './modules/regulations/regulations.module';
import { MetricsModule } from './modules/metrics/metrics.module';
import { CustomerSegmentsModule } from './modules/customer-segments/customer-segments.module';
import { DevicesModule } from './modules/devices/devices.module';
import { LoyalizationModule } from './modules/loyalization/loyalization.module';
import { SalesChannelModule } from './modules/sales-channels/sales-channel.module';
import { BusinessRulesModule } from './modules/business-rules/business-rules.module';
import { MatPaginatorIntl } from '@angular/material';
import { MatPaginatorIntlCro } from './helpers/paginator-translate';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AuthModule,
    MaterialModule,
    ServicesModule,
    OffersModule,
    ProductsModule,
    OfferLifecycleModule,
    RegulationsModule,
    MetricsModule,
    CustomerSegmentsModule,
    DevicesModule,
    SalesChannelModule,
    LoyalizationModule,
    BusinessRulesModule,
    ToastModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    CookieService,
    AuthGuard,
    {
      provide: MatPaginatorIntl,
      useFactory: translate => {
        const service = new MatPaginatorIntlCro(translate);
        service.injectTranslateService(translate);
        return service;
      },
      deps: [TranslateService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts